import { LoggerService } from '@app/shared/services/logger.service';
import { MatDialog } from '@angular/material/dialog';
import { MtxDrawer } from '@ng-matero/extensions/drawer';
import { SiteTourService } from '@app/shared/services/site-tours.service';
import { BannerNotificationsService } from '@app/shared/services/banner-notifications.service';
import { AdminUser } from '@app/shared/services/user.service';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { PanelWidths } from '@app/shared/constants';
import {
  EditHotspotsComponent
} from '@app/pages/authenticated/pages/site-tours/components/edit-hotspots/edit-hotspots.component';
import { ModalConfirmationComponent } from '@app/shared/components/modal-confirmation/modal-confirmation.component';

@Component({
  standalone: false,
  selector: 'app-list-hotspots',
  templateUrl: './list-hotspots.component.html',
})
export class ListHotspotsComponent implements OnInit {
  @Input() user: AdminUser;
  @Input() canEdit: boolean = false;

  public isLoading: boolean = true;
  public hotspots: any[] = [];
  public displayColumns: string[] = ['name', 'page', 'status', 'actions'];
  public CDN_URL: string = environment.CDN_URL;

  constructor(
    private logger: LoggerService,
    private dialog: MatDialog,
    private drawer: MtxDrawer,
    private siteTourService: SiteTourService,
    private bannerNotificationsService: BannerNotificationsService
  ) {}

  ngOnInit() {
    this.isLoading = true;
    if (this.user) {
      this.loadHotspots();
    }
  }

  public loadHotspots(): void {
    this.isLoading = true;
    this.siteTourService.getAllHotspots()
      .subscribe(
        (hotspots: any) => {
          this.hotspots = hotspots;
          this.isLoading = false;
          this.logger.log('GET site hotspots', hotspots);
        },
        (error) => {
          this.bannerNotificationsService.error(`Failed to load hotspots: ${error.message}`);
          this.logger.error('GET site hotspots error', error);
          this.isLoading = false;
        }
      );
  }

  public openHotspotDrawer(selectedHotspot?: any): void {
    if (this.canEdit) {
      const drawerRef = this.drawer.open(EditHotspotsComponent, {
        width: PanelWidths.desktopFull,
        disableClose: true,
        closeOnNavigation: false,
        data: { hotspot: selectedHotspot },
      });
      drawerRef.afterDismissed().subscribe((result) => {
        if (result) {
          this.bannerNotificationsService.success('Site hotspot was saved');
          this.loadHotspots();
        }
      });
    }}

  public toggleHotspot(hotspot: any): void {
    if (this.canEdit) {
      this.siteTourService.toggleHotspot(hotspot.id)
        .subscribe(
          updatedHotspot => {
            hotspot.isActive = updatedHotspot.isActive;
          },
          error => {
            this.bannerNotificationsService.error(`Failed to toggle hotspot: ${error.message}`);
            this.logger.error('UPDATE active site hotspots error', error);
          }
        )
    }
  }

  public editHotspot(hotspot: any): void {
    this.openHotspotDrawer(hotspot);
  }

  public deleteHotspot(hotspot: any): void {
    if (this.canEdit) {
      const dialogRef = this.dialog.open(ModalConfirmationComponent, {
        data: {
          title: 'Delete Site Hotspot',
          content: `Are you sure you want to delete the hotspot "${hotspot.name}"?`,
          confirmBtnLabel: 'Delete',
          btnColor: 'warn',
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.siteTourService.deleteHotspot(hotspot.id)
            .subscribe(
              () => {
                this.loadHotspots();
              },
              error => {
                this.bannerNotificationsService.error(`Failed to delete hotspot: ${error.message}`);
                this.logger.error('UPDATE delete site hotspot error', error);
              }
            );
        }
      });
    }
  }
}
